import React, { FormEvent, Ref, useRef } from 'react';
import { Image } from 'react-bootstrap';
import SearchIcon from 'assets/menu-list-icon/search.svg';
import CloseIcon from 'assets/icon/x.svg';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ClearButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  right: 8px;
  top: 8px;
  color: ${(props) => props.theme.colors.ghost};
`;

interface Props {
  onSearch?: (term: string) => void;
  showCancel?: boolean;
}

const Search = ({ onSearch, showCancel = false }: Props) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>();

  const onInput = (e: FormEvent<HTMLInputElement>) => {
    if (!onSearch) return;
    onSearch((e.target as HTMLInputElement).value);
  };

  const onClear = () => {
    if (!onSearch || !inputRef?.current) return;
    onSearch('');
    inputRef.current.value = '';
  };

  return (
    <div className="input-icon w-100 h-40px" style={{ position: 'relative' }}>
      <span>
        <span className="svg-icon svg-icon-lg">
          <Image src={SearchIcon} />
        </span>
      </span>
      <input
        ref={inputRef as Ref<HTMLInputElement>}
        type="text"
        className="form-control form-control-lg form-control-solid h-40px"
        placeholder={t('txt_search')}
        id="general-search"
        autoComplete="false"
        onInput={onInput}
      />
      {showCancel && inputRef?.current?.value !== '' ? (
        <ClearButton onClick={onClear} id="search-clear-button">
          <SVG src={CloseIcon} width="14" height="14" />
        </ClearButton>
      ) : null}
    </div>
  );
};

export default Search;
